import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { createAdminUser } from "../Apihelper/ApiHelperUser";
import CancelIcon from "@mui/icons-material/Cancel";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";

import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import AppToast from '../../components/Toast/AppToast';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

// Sidebar menu options for page access (must match Header menu items)
const SIDEBAR_PAGE_OPTIONS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "follow up", label: "Follow Up" },
  { id: "members", label: "Members" },
  { id: "bulk whatsapp", label: "Bulk holiday WhatsApp" },
  { id: "packages", label: "Packages" },
  { id: "offers", label: "Offers" },
  { id: "due users", label: "Due Users" },
  { id: "balance", label: "Balance" },
  { id: "pt", label: "Pt" },
  { id: "diet", label: "Diet" },
  { id: "exercise", label: "Exercise" },
  { id: "expense", label: "Expense" },
  { id: "staff", label: "Staff" },
  { id: "users", label: "Users" },
  { id: "attendance", label: "Attendance" },
  { id: "operation logs", label: "Operation logs" },
  { id: "device logs", label: "Device Command Logs" },
];

function AddUser(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const dateRef = useRef();

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      navigate('/');
    }
  }, [navigate]);
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      border: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [UseradminData, setUseradminData] = useState({
    username: "",
    fullname: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    userType: "",
    balanceSheetPassword: "",
  });
  const [pageAccess, setPageAccess] = useState({});
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showBalanceSheetPassword, setShowBalanceSheetPassword] = useState(false);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "userType" && value !== "user") {
      setPageAccess({});
    }
    setUseradminData({
      ...UseradminData,
      [name]: name === "email" ? value.toLowerCase() : (name === "userType" ? value : value.toUpperCase()),
      ...(name === "userType" && value !== "admin" && value !== "user" ? { balanceSheetPassword: "" } : {}),
    });
  };

  const handlePageAccessChange = (id, checked) => {
    setPageAccess((prev) => ({ ...prev, [id]: checked }));
  };

  const handleSelectAllPages = (checked) => {
    const next = {};
    SIDEBAR_PAGE_OPTIONS.forEach((opt) => { next[opt.id] = checked; });
    setPageAccess(next);
  };
  
  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!UseradminData.username) newErrors.username = "Username is required";
    if (!UseradminData.fullname) newErrors.fullname = "Full name is required";
    if (!UseradminData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(UseradminData.phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }
    if (!UseradminData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(UseradminData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!UseradminData.password) {
      newErrors.password = "Password is required";
    } else if (UseradminData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (UseradminData.password !== UseradminData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    if (!UseradminData.userType) {
      newErrors.userType = "User type is required";
    }
    if (UseradminData.userType === "user") {
      const selected = Object.keys(pageAccess).filter((k) => pageAccess[k]);
      if (selected.length === 0) {
        newErrors.pageAccess = "Select at least one page the user can access";
      }
    }
    if (
      (UseradminData.userType === "admin" || UseradminData.userType === "user") &&
      UseradminData.balanceSheetPassword &&
      UseradminData.balanceSheetPassword.length < 4
    ) {
      newErrors.balanceSheetPassword = "Balance sheet password must be at least 4 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validate()) {
      handleSnackbarOpen("Please fix the errors in the form", "error");
      return;
    }

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;

      const payload = {
        ...UseradminData,
        page_access:
          UseradminData.userType === "user"
            ? Object.keys(pageAccess).filter((k) => pageAccess[k])
            : undefined,
      };
      const res = await createAdminUser(userToken, payload);
      
      if (res.code === "200" || res.code === 200) {
        handleSnackbarOpen(res.message, "success");
        clearForm();
        navigate("/userlist");
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("An error occurred while creating the user", "error");
    }
  };

  const clearForm = () => {
    setUseradminData({
      username: '',
      fullname: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      userType: '',
      balanceSheetPassword: '',
    });
    setPageAccess({});
    setErrors({});
  };
  return (
    <Box
      sx={{ display: "flex", backgroundColor: "#EFEDF1", minHeight: "100vh" }}
    >
      <Header />
      <CssBaseline />
      <Box
        component="main"
        sx={{ flexGrow: 1, overflowY: "auto", padding: "20px" }}
      >
        <div style={{ display: "flex", flexGrow: 1, marginTop: "50px" }}>
          <div style={{ flex: 1, marginTop: "15px" }}>
            <Box sx={{ 
              display: "flex", 
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              backgroundColor: "white",
              borderRadius: 2,
              p: 2,
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)'
            }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => navigate(-1)}
                  sx={{
                    color: appColors.leaf,
                    borderColor: appColors.leaf,
                    '&:hover': {
                      borderColor: appColors.pine,
                      bgcolor: 'rgba(31, 122, 84, 0.04)'
                    },
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: 2,
                    px: 2
                  }}
                >
                  Back
                </Button>
                <Box>
                  <Typography variant="h5" sx={{ 
                    color: appColors.leaf, 
                    fontWeight: 600,
                    mb: 0.5
                  }}>
                    Add New User
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#6b7280' }}>
                    Create a new user account with role-based access
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="contained"
                onClick={() => navigate("/userlist")}
                startIcon={<CheckCircleIcon />}
                sx={{
                  bgcolor: appColors.leaf,
                  '&:hover': { bgcolor: appColors.pine },
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  boxShadow: '0px 2px 4px rgba(31, 122, 84, 0.1)'
                }}
              >
                View All Users
              </Button>
            </Box>

            <Card sx={{ 
              p: 2, 
              borderRadius: 2,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
            }}>
              <Grid container spacing={3}>
                <Grid size={{ xs: 12}}>
                  <Typography variant="subtitle1" sx={{ color: appColors.leaf, fontWeight: 600, }}>
                    Personal Information
                  </Typography>
                </Grid>
                <Grid  size={{ xs: 12,md: 6}}>
                  <TextField
                    fullWidth
                    name="username"
                    label="Username"
                    value={UseradminData.username}
                    onChange={handleChange}
                    error={!!errors.username}
                    helperText={errors.username}
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid  size={{ xs: 12,md: 6}}>
                  <TextField
                    fullWidth
                    name="fullname"
                    label="Full Name"
                    value={UseradminData.fullname}
                    onChange={handleChange}
                    error={!!errors.fullname}
                    helperText={errors.fullname}
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid  size={{ xs: 12}}>
                  <Typography variant="subtitle1" sx={{ color: appColors.leaf, fontWeight: 600, }}>
                    Contact Information
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12,md: 6}}>
                  <TextField
                    fullWidth
                    name="email"
                    label="Email"
                    type="email"
                    value={UseradminData.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid  size={{ xs: 12,md: 6}}>
                  <TextField
                    fullWidth
                    name="phone"
                    label="Phone"
                    type="number"
                    value={UseradminData.phone}
                    onChange={handleChange}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid item  size={{ xs: 12}}>
                  <Typography variant="subtitle1" sx={{ color: appColors.leaf, fontWeight: 600,  }}>
                    Role & Access
                  </Typography>
                </Grid>
                <Grid  size={{ xs: 12}}>
                  <FormControl 
                    fullWidth 
                    size="small"
                    error={!!errors.userType}
                  >
                    <InputLabel>User Type</InputLabel>
                    <Select
                      name="userType"
                      value={UseradminData.userType}
                      label="User Type"
                      onChange={handleChange}
                      sx={{
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }}
                    >
                      <MenuItem value="">Select User Type</MenuItem>
                      <MenuItem value="admin">Admin</MenuItem>
                      <MenuItem value="user">User</MenuItem>
                      <MenuItem value="editor">Editor</MenuItem>
                      <MenuItem value="viewer">Viewer</MenuItem>
                    </Select>
                    {errors.userType && (
                      <Typography variant="caption" color="error">
                        {errors.userType}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {(UseradminData.userType === "admin" || UseradminData.userType === "user") && (
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      name="balanceSheetPassword"
                      label="Balance Sheet Password"
                      type={showBalanceSheetPassword ? "text" : "password"}
                      value={UseradminData.balanceSheetPassword}
                      onChange={handleChange}
                      error={!!errors.balanceSheetPassword}
                      helperText={errors.balanceSheetPassword || "Password this admin will use to unlock the Balance Sheet page"}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowBalanceSheetPassword((prev) => !prev)}
                              edge="end"
                              size="small"
                            >
                              {showBalanceSheetPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 1,
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: appColors.leaf
                          }
                        }
                      }}
                    />
                  </Grid>
                )}
                {UseradminData.userType === "user" && (
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle1" sx={{ color: appColors.leaf, fontWeight: 600, mb: 1 }}>
                      Page access (which pages this user can access)
                    </Typography>
                    <FormControl error={!!errors.pageAccess} component="fieldset" fullWidth>
                      <FormGroup row sx={{ flexWrap: "wrap", gap: 0.5 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                SIDEBAR_PAGE_OPTIONS.length > 0 &&
                                SIDEBAR_PAGE_OPTIONS.every((opt) => pageAccess[opt.id])
                              }
                              indeterminate={
                                Object.keys(pageAccess).some((k) => pageAccess[k]) &&
                                !SIDEBAR_PAGE_OPTIONS.every((opt) => pageAccess[opt.id])
                              }
                              onChange={(e) => handleSelectAllPages(e.target.checked)}
                            />
                          }
                          label="Select all"
                        />
                        {SIDEBAR_PAGE_OPTIONS.map((opt) => (
                          <FormControlLabel
                            key={opt.id}
                            control={
                              <Checkbox
                                checked={!!pageAccess[opt.id]}
                                onChange={(e) => handlePageAccessChange(opt.id, e.target.checked)}
                              />
                            }
                            label={opt.label}
                          />
                        ))}
                      </FormGroup>
                      {errors.pageAccess && (
                        <FormHelperText>{errors.pageAccess}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                )}
                <Grid size={{ xs: 12}}>
                  <Typography variant="subtitle1" sx={{ color: appColors.leaf, fontWeight: 600, }}>
                    Security
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12,md: 6}}>
                  <TextField
                    fullWidth
                    name="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    value={UseradminData.password}
                    onChange={handleChange}
                    error={!!errors.password}
                    helperText={errors.password}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                            size="small"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12,md: 6}}>
                  <TextField
                    fullWidth
                    name="confirmPassword"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={UseradminData.confirmPassword}
                    onChange={handleChange}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                            edge="end"
                            size="small"
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1,
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: appColors.leaf
                        }
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Box sx={{ 
                display: "flex", 
                justifyContent: "flex-end", 
                gap: 2, 
                mt: 2 
              }}>
                <Button
                  variant="outlined"
                  startIcon={<CancelIcon />}
                  onClick={clearForm}
                  sx={{
                    color: appColors.leaf,
                    borderColor: appColors.leaf,
                    '&:hover': {
                      borderColor: appColors.pine,
                      bgcolor: 'rgba(31, 122, 84, 0.04)'
                    },
                    textTransform: "none",
                    fontWeight: 600
                  }}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  startIcon={<CheckCircleIcon />}
                  onClick={handleSubmit}
                  sx={{
                    bgcolor: appColors.leaf,
                    '&:hover': { bgcolor: appColors.pine },
                    textTransform: "none",
                    fontWeight: 600
                  }}
                >
                  Create User
                </Button>
              </Box>
            </Card>
          </div>
        </div>
      </Box>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default AddUser;
